<script lang="ts" setup>
import type { PropType } from 'vue';
type LoginType = 'column' | 'row';

const { t } =  useI18n({
  useScope: "local",
});


defineOptions({
  inheritAttrs: false,
});

const emit = defineEmits<{
  (event: 'click:register'): void;
  (event: 'click:login'): void;
}>();

const props = defineProps({
  buttonText: {
    type: String,
    default: null,
  },
  dataTrackingId: {
    type: String as PropType<string | string[]>,
    default: '',
  },
  dataPage: {
    type: String,
    default: '',
  },
  showLogin: {
    type: Boolean,
    default: true,
  },
  loginType: {
    type: String as PropType<LoginType>,
    default: 'row',
  },
  enableTracking: {
    type: Boolean,
    default: true,
  },
});

const buttonLabel = computed(() => props.buttonText || t('register_now'));
</script>

<template>
  <section class="register-button" :aria-label="t('registration_and_login')">
    <tw-ui-action
      :class="props.enableTracking ? 'tw-tracking' : ''"
      @click="emit('click:register')"
      is="link"
      variant="button-primary"
      to="/registrieren"
      :aria-label="buttonLabel"
      v-bind="props.enableTracking ? { 'data-page': props.dataPage, 'data-tracking-id': props.dataTrackingId, 'data-button-text': buttonLabel, 'data-button-color': 'primary' } : {}"
    >
      {{ buttonLabel }}
    </tw-ui-action>
    <div class="register-button-login" :style="`flex-direction:${props.loginType}`">
      <span>{{ t('already_an_account') }}</span>
      <tw-ui-action
        :class="props.enableTracking ? 'tw-tracking' : ''"
        @click="emit('click:login')"
        is="link"
        variant="text"
        to="/login"
        :aria-label="t('login_now')"
        v-bind="props.enableTracking ? { 'data-page': props.dataPage, 'data-tracking-id': props.dataTrackingId, 'data-button-text': t('login_now') } : {}"
      >
        {{ t('login_now')}}
      </tw-ui-action>
    </div>
  </section>
</template>

<style scoped lang="scss">
section.register-button {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  div {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }
}
</style>

<i18n lang="json">
{
  "de": {
   "registration_and_login": "Registrierung und Anmeldung",
    "register_now": "Jetzt registrieren",
    "already_an_account": "Du hast bereits ein Konto? ",
    "login_now": "Jetzt anmelden"
  },
  "en": {
    "registration_and_login": "Registration and login",
    "register_now": "Register now",
    "already_an_account": "Already have an account? ",
    "login_now": "Log in now"
  }
}
</i18n>
